import { makeStyles } from '@mui/styles';
import { minWidth } from '@mui/system';
import theme from 'src/style-system/theme';

export const useStyles = ({ variation }: any) => {
  const SECOND_VARIATION = 'viewOurPlan';
  const THIRD_VARIATION = 'contactUs';

  return makeStyles({
    container: {
      padding: variation === SECOND_VARIATION ? '20px 25px' : '25px 25px',
      width: '100%',
      display: 'flex',
      flexDirection: variation === THIRD_VARIATION ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '10px',
      rowGap: '10px',
      background: theme.palette.cinnamon.main,
      // boxShadow:
      //   variation === SECOND_VARIATION
      //     ? '0px -10px 20px rgba(0, 0, 0, 0.25)'
      //     : 'none',

      [theme.breakpoints.up('sm')]: {
        columnGap: '30px',
        flexDirection: 'row',
        padding: variation === SECOND_VARIATION ? '20px 50px' : '25px 50px',
      },
    },

    btn: {
      [theme.breakpoints.down('sm')]: {
        minWidth: variation === SECOND_VARIATION ? '200px' : '155px',
        width: variation === SECOND_VARIATION ? '200px' : '155px',
      },
    },
  });
};
